export function initAccordions(scope = document) {
    const DURATION = 300; // ms

    // --- Helpers ---
    function collapseElement(el) {
        // Set explicit height so the transition has a start value
        el.style.height = el.scrollHeight + 'px';
        el.style.opacity = '1';
        // Force reflow so the browser registers the starting value
        el.offsetHeight; // eslint-disable-line no-unused-expressions
        el.style.overflow = 'hidden';
        el.style.height = '0';
        el.style.opacity = '0';
    }

    function expandElement(el) {
        const targetHeight = el.scrollHeight;
        el.style.overflow = 'hidden';
        el.style.height = '0';
        el.style.opacity = '0';
        el.offsetHeight; // eslint-disable-line no-unused-expressions
        el.style.height = targetHeight + 'px';
        el.style.opacity = '1';

        // Clean up after transition completes
        const onEnd = () => {
            el.style.height = '';
            el.style.overflow = '';
            el.removeEventListener('transitionend', onEnd);
        };
        el.addEventListener('transitionend', onEnd);
    }

    function ensureTransitionStyles(el) {
        if (!el.dataset.accordionReady) {
            el.style.transition = `height ${DURATION}ms ease, opacity ${DURATION}ms ease`;
            el.dataset.accordionReady = 'true';
        }
    }

    // --- .js-accordion pattern ---
    scope.querySelectorAll('.js-accordion').forEach(accordion => {
        const target = accordion.querySelector('.js-accordionTarget');
        const trigger = accordion.querySelector('.js-accordionTrigger');

        ensureTransitionStyles(target);

        trigger.addEventListener('click', (e) => {
            if (document.body.clientWidth >= 1140 && accordion.classList.contains('js-accordion_mobileOnly')) {
                return;
            }
            e.preventDefault();

            const isOpen = trigger.classList.contains('isOpen');

            trigger.classList.toggle('isOpen');
            target.classList.toggle('isOpen');

            if (isOpen) {
                collapseElement(target);
            } else {
                expandElement(target);
            }
        });
    });

    // --- .accordionHead pattern ---
    scope.querySelectorAll('.accordionHead').forEach(header => {
        const accordionBody = header.nextElementSibling;
        ensureTransitionStyles(accordionBody);

        header.addEventListener('click', () => {
            if (header.classList.contains('minus')) {
                // Collapse
                collapseElement(accordionBody);
                header.classList.remove('minus');
                header.classList.add('plus');
            } else {
                // Expand
                header.classList.remove('plus');
                header.classList.add('minus');
                expandElement(accordionBody);
            }
        });
    });
}

initAccordions();
